import fetchProduct from "../helpers/useProduct/fetchProduct";
import resolveInitialVariant from "../helpers/resolveInitialVariant";
import { sourceFromVariant, trackViewItem } from "../helpers/dataLayer";

/**
 * Pushes dl_view_item, once, when its parent element — the product form's
 * container — first scrolls into view, or straight away when `immediate`.
 * Rendered `hidden`, so it never affects the layout it sits in.
 */
class DlViewItem extends HTMLElement {
  connectedCallback() {
    const target = this.parentElement;
    if (this.viewed || !target) return;

    if (this.hasAttribute("immediate")) {
      this.viewed = true;
      this.track();
      return;
    }

    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;

      this.viewed = true;
      this.observer.disconnect();
      this.track();
    });

    this.observer.observe(target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  track() {
    fetchProduct(this.getAttribute("product-id")).then((product) => {
      if (!product) return;

      const variant = resolveInitialVariant({
        product,
        initialVariantId: this.getAttribute("initial-variant-id"),
      });

      if (variant) trackViewItem(sourceFromVariant(variant));
    });
  }
}

if (!customElements.get("dl-view-item")) {
  customElements.define("dl-view-item", DlViewItem);
}
